import React from 'react';
import SliderFilter from './SliderFilter';

const MATCH_IDS = [3];

export default function HospitalExpenseFilter({ useStagingMode = false, onStageChange = null }) {
  return (
    <SliderFilter
      matchIds={MATCH_IDS}
      title="Despesa Médica Hospitalar"
      description="Selecione o valor desejado para suas despesas médicas e hospitalares durante a viagem"
      infoTooltip="É o valor máximo de cobertura para atendimentos médicos e hospitalares durante a viagem, como consultas, exames e internações."
      ariaLabel="Despesa Médica Hospitalar"
      useStagingMode={useStagingMode}
      onStageChange={onStageChange}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/v2/search/components/filter/components/HospitalExpenseFilter.jsx